<header class="section-header">
  <h2>خلاصه امضای الکتریکی</h2>
  <span lang="en">ELECTRICAL</span>
</header>
<dl class="metrics">
  <div class="metric-row" *ngFor="let metric of metrics">
    <dt>{{ metric.label }}</dt>
    <dd dir="ltr">{{ formatValue(context.summary, metric.field, metric.decimals, metric.unit) }}</dd>
  </div>
</dl>
